// Depth (Neptune): the two stars at the ends of a constellation's longest
// line score more.
import { ALIGNMENT_NUMBERS as N } from '../constants';
import { longestLineEnds } from '../shared/geometry';
import type { AlignmentDef } from '../types';

export const depth: AlignmentDef = {
  id: 'depth',
  planet: 'neptune',
  name: 'Depth',
  text: () => `The two stars of the longest line in every constellation score +${N.depthPercent}%.`,
  starPercent: (star, c, ctx) => (longestLineEnds(ctx, c.constellation).has(star.node.id) ? N.depthPercent : 0),
};
